// extracted by mini-css-extract-plugin
export default {"add_buttons":"styles_add_buttons__08bsm"};